<template>
  <div class="wrapper" id="index">
    <main>
      <div class="mainContent">
        <div class="insuranceTitle">关税保证保险</div>
        <div class="presentation">由保险公司为企业提供关税担保，在货物通关时，凭借“一张保单”即可享受“先放行后缴税”</div>
        <ul class="unit flex-wrap">
          <li>
            <div class="offerTesting space-between" @click='goTo("/haoLian/offerTesting")'>
              <img src="../../../../static/images/product/haoLian/startPages01.png">
              <div class="themeUnit">
                <div>保费测算</div>
                <div>科学测算，数据直观</div>
              </div>
            </div>
          </li>
          <li>
            <div class="fillInfo space-between" @click='goTo("/haoLian/fillInfo")'>
              <img src="../../../../static/images/product/haoLian/startPages02.png">
              <div class="themeUnit">
                <div>我要投保</div>
                <div>操作简单，便捷高效</div>
              </div>
            </div>
          </li>
          <li>
            <div class="orderManagement space-between" @click='goTo("/haoLian/orderManagement")'>
              <img src="../../../../static/images/product/haoLian/startPages03.png">
              <div class="themeUnit">
                <div>订单管理</div>
                <div>一键操作，智能管理</div>
              </div>
            </div>
          </li>
          <li>
            <div class="insuranceManagement space-between" @click='goTo("/haoLian/insuranceManagement")'>
              <img src="../../../../static/images/product/haoLian/startPages04.png">
              <div class="themeUnit">
                <div>保单管理</div>
                <div>保障查询，一目了然</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </main>
  </div>
</template>

<script>
  import $$ from "../../../tool/BaseXJT";

  export default {
    name: "index",
    data() {
      return {
      }
    },
    methods:{
      goTo(title){
        if (!$$.isValidObj(this.token)) {
          console.log(1)
          this.$$.alert({message: "请求未带标识，token不能为空!"});
          return false;
        }
        this.$$.isValidObj(this.token) ? this.$router.push({path: `${title}`, query: {token: this.token}}) : this.$router.push({path: `${title}`});
      },
    },
    mounted() {
      let mainHeight = $('html').height() - ($('header').height() + $('footer').height());
      $('.wrapper>main').css('min-height', mainHeight);

      this.token = this.$route.query.token;
    },
  }
</script>

<style scoped>
  /* 内容 */
  .wrapper>main{
    padding: 1.5rem 0rem;
  }
  .mainContent{
    width: 80%;
    margin: 0 auto;
    padding: 5.94rem 0rem 3.25rem;
    background: #FFFFFF;
    box-shadow: 0rem 0rem 1rem 0rem rgba(203, 203, 203, 0.2);
  }
  .insuranceTitle{
    width: 80%;
    margin: 0 auto;
    font-size: 2.5rem;
    font-weight: bold;
    color: #333333;
  }
  .presentation{
    width: 80%;
    margin: 0 auto;
    font-size: 1rem;
    font-weight: 400;
    color: #333333;
  }
  .mainContent>.unit{
    width: 80%;
    margin: 4rem auto 0;
  }
  .mainContent>.unit>li{
    min-width: 50%;
    margin: 0 auto;
    padding-right: 1rem;
  }
  .mainContent>.unit>li>div{
    width: 22rem;
    height: 10rem;
    border-radius: 2rem;
    margin: 0 auto 4.5rem;
    padding: 2rem 8%;
    vertical-align: middle;
    cursor: pointer;
  }
  .offerTesting{
    background: linear-gradient(0deg, #2284E6 0%, #409FFF 100%);
  }
  .fillInfo{
    background: linear-gradient(0deg, #FF531A 0%, #FF791A 100%);
  }
  .orderManagement{
    background: linear-gradient(0deg, #FFAA00 0%, #FFCC33 100%);
  }
  .insuranceManagement{
    background: linear-gradient(0deg, #56BF79 0%, #78E495 100%);
  }

  .offerTesting>img{
    width: 6.63rem;
    height: 5.94rem;
  }
  .fillInfo>img{
    width: 6.06rem;
    height: 6rem;
  }
  .orderManagement>img{
    width: 6.06rem;
    height: 6rem;
  }
  .insuranceManagement>img{
    width: 6.13rem;
    height: 6rem;
  }

  .themeUnit{
    padding-top: 0.6rem;
  }

  .themeUnit>div:nth-child(1){
    font-size: 1.75rem;
    font-weight: 800;
    color: #FFFFFF;
  }
  .themeUnit>div:nth-child(2){
    font-size: 1rem;
    font-weight: 500;
    color: #FFF2D8;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/haoLian/index.vue